module.exports = __webpack_public_path__ + "img/img_startupInfo.d98a6872.png";